const proxyUrl = (process.env.PROXY || window.location.href).split('/')[2]
const rawDomain = window.location.hostname
const domainMatch = !rawDomain.match(/localhost|0\.0\.0\.0/i) ? rawDomain : proxyUrl
const domain = domainMatch === 'www.fromcounsel.com' ? 'prod.fromcounsel.com' : domainMatch

export default `https://image-${domain}/unsafe/(:fitPart/):size/:url`
